import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import logoSmartEfi from "@/assets/logo-smart-efi.webp";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { LogOut, User, ChevronDown, Monitor } from "lucide-react";
import { ThemeToggle } from "@/components/layout/ThemeToggle";

interface HubHeaderProps {
  initials: string;
  displayName: string;
  email: string | null | undefined;
}

export function HubHeader({ initials, displayName, email }: HubHeaderProps) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate("/auth");
  };

  return (
    <header className="border-b border-border/60 bg-card/80 backdrop-blur-md sticky top-0 z-30">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img src={logoSmartEfi} alt="Smart-EFI" className="w-9 h-9 rounded-xl object-cover shadow-md shadow-primary/20" />
          <span className="text-lg font-bold tracking-tight font-display">Smart-EFI</span>
        </div>
        <div className="flex items-center gap-2">
          <ThemeToggle />
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button className="flex items-center gap-2 px-2 py-1.5 rounded-lg hover:bg-muted transition-colors">
                <div className="w-7 h-7 rounded-full bg-gradient-to-br from-violet-500/20 to-indigo-500/20 text-primary flex items-center justify-center text-xs font-bold ring-1 ring-primary/10">
                  {initials}
                </div>
                <span className="text-sm font-medium hidden sm:block max-w-[160px] truncate">{displayName}</span>
                <ChevronDown className="w-3 h-3 text-muted-foreground" />
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56">
              <div className="px-3 py-2">
                <p className="text-sm font-medium">{displayName}</p>
                <p className="text-xs text-muted-foreground">{email}</p>
              </div>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={() => navigate("/settings/profile")} className="gap-2">
                <User className="w-4 h-4" /> Mon profil
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => navigate("/settings/profile?tab=devices")} className="gap-2">
                <Monitor className="w-4 h-4" /> Mes appareils
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={handleLogout} className="gap-2 text-destructive focus:text-destructive">
                <LogOut className="w-4 h-4" /> Déconnexion
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}
